export const MODES = {
  NOTEXAM: ['LEARNNEW', 'REVIEW'],
  EXAM: ['EXAMSIMULATION', 'EXAM'],
  FORCEREVIEW: 'FORCEREVIEW'
}

export const PRACTICEMODE = {
  NORMAL: false,
  SKIPTYPING: true
}
